import React from 'react'
import {TooltipProps} from 'recharts'

export const CustomTooltip: React.FC<TooltipProps<number, string>> = ({active, payload, label}) => {
  if (!active || !payload || !payload.length) return null

  const allUsersPayload = payload.find((item) => item.dataKey === 'allUsers')
  const allUsers = allUsersPayload?.value ?? 0

  return (
    <div
      style={{
        background: '#fff',
        padding: '0.5rem',
        border: '1px solid #ccc',
      }}
    >
      <p>
        <strong>{label}</strong>
      </p>
      {payload.map((item, index) => {
        const name = item.name ?? 'Okänd'
        const value = item.value ?? 0
        const color = item.color ?? '#000'

        if (item.dataKey === 'allUsers') {
          return (
            <p key={index} style={{color, margin: 0}}>
              {name}: {value} (100%)
            </p>
          )
        }

        if (item.dataKey === 'paymentShare' || item.dataKey === 'rentalShare') {
          return (
            <p key={index} style={{color, margin: 0}}>
              {name}: {value}%
            </p>
          )
        } else {
          const percentage =
            allUsers > 0 && item.dataKey !== 'allUsers' ? ((value / allUsers) * 100).toFixed(1) : item.dataKey === 'allUsers' ? '100.0' : '0.0'

          return (
            <p key={index} style={{color, margin: 0}}>
              {name}: {value} ({percentage}%)
            </p>
          )
        }
      })}
    </div>
  )
}
